import React from "react";
import { Container } from "./Container";
import "./Section.css";

type Props = {
  id?: string;
  eyebrow?: string;
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  variant?: "default" | "soft";
};

export function Section({ id, eyebrow, title, subtitle, children, variant = "default" }: Props) {
  return (
    <section id={id} className={`section ${variant === "soft" ? "sectionSoft" : ""}`}>
      <Container>
        <div className="sectionHead">
          {eyebrow ? <div className="sectionEyebrow">{eyebrow}</div> : null}
          <h2 className="sectionTitle">{title}</h2>
          {subtitle ? <p className="sectionSubtitle">{subtitle}</p> : null}
        </div>

        <div className="sectionBody">{children}</div>
      </Container>
    </section>
  );
}